import { defineStore } from 'pinia'
import { ref } from 'vue'
import { sessionStorage } from '@shared/helpers/storage'

export const useEuStore = defineStore(
  'eu/app',
  () => {
    // State
    const formData = ref({
      acceptData: false,
      acceptMarketing: false,
      acceptPhoneCall: false,
      acceptTerms: false,
      acceptTracking: false,
      confirmed: false,
      dateOfBirth: '',
      email: '',
      emailCode: '',
      lastName: '',
      firstName: '',
      password: '',
      voucherCode: '',
      // EU specific fields
      insuranceNumber: '',
      insuranceName: '',
      prescriptionCode: '',
    })

    const signupContext = ref({
      webEntryPointUrl: '',
      webEntryPointReferrerUrl: '',
      howDidYouHearAboutUs: '',
    })

    const startRoute = ref('')
    const prescriptionQuestionAnswers = ref({
      hasPrescription: null,
      hasCode: null,
    })

    // Whether the self-submit flow already showed the prescriber-information
    // screen (it is only asked once per session).
    const prescriberInformationShown = ref(false)

    // Actions
    function updateFormData(data) {
      formData.value = { ...formData.value, ...data }
    }

    function updateSignupContext({
      webEntryPointUrl,
      webEntryPointReferrerUrl,
    }) {
      // only update the fields in the signup context if they were not set yet
      signupContext.value.webEntryPointUrl ||= webEntryPointUrl
      signupContext.value.webEntryPointReferrerUrl ||= webEntryPointReferrerUrl
    }

    function updateHowDidYouHearAboutUs(value) {
      signupContext.value.howDidYouHearAboutUs = value
    }

    return {
      // State
      formData,
      signupContext,
      startRoute,
      prescriptionQuestionAnswers,
      prescriberInformationShown,
      // Actions
      updateHowDidYouHearAboutUs,
      updateFormData,
      updateSignupContext,
    }
  },
  {
    persist: {
      storage: sessionStorage,
    },
  },
)

export default useEuStore
